export default __webpack_public_path__ + "static/media/ei_board.e18dd2ca.png";